import { useContext } from 'react';
import { StoreContext } from 'stores/helpers/StoreContext';

const useStores = () => {
  return useContext(StoreContext);
};

export default useStores;
